
import { Component, inject, OnInit } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { NavigationComponent } from "../../components/navigation/navigation.component";
import { AssignmentService } from "../../services/assignment.service";
import { TitleService } from "../../services/title.service";

@Component({
    selector: "app-assignment-container",
    standalone: true,
    imports: [RouterOutlet, NavigationComponent],
    templateUrl: "./assignment-container.component.html",
    styleUrl: "./assignment-container.component.scss",
})
export class AssignmentContainerComponent implements OnInit {
    protected readonly assignmentsService = inject(AssignmentService);
    private readonly titleService = inject(TitleService);
    private readonly router = inject(Router);

    ngOnInit() {
        const plannedAssignment = this.assignmentsService?.selectedPlannedAssignment;
        this.titleService.goBack.set(["/assignments"]);
        this.titleService.title = plannedAssignment?.assignment?.parentAssignment
            ? `${plannedAssignment?.assignment?.parentAssignment.name} - ${plannedAssignment?.assignment?.name}`
            : plannedAssignment?.assignment?.name;
    }

    getPlannedAssignmentId(): number {
        if (!this.assignmentsService?.selectedPlannedAssignment?.id) {
            this.router.navigate(["/assignments"]);
            return;
        }
        return this.assignmentsService?.selectedPlannedAssignment?.id;
    }
}
